module.exports = __webpack_public_path__ + "static/pug.82aadc57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/pug.svg
// module id = 553
// module chunks = 35783957827783